<template>
    <div v-if="configuration">
        <div class="touch__flex" :class="getTouchFlexLayoutClass(configuration)">
            <template v-if="$store.state.showLaserOverlay && $store.state.userData && $store.state.userData.content && $store.state.userData.content.contact_id && $store.state.userData.content.contact_id == '62887a07-2de4-49d5-a95a-e6e6871310eb'">
                <img style="width: 100%;height: 100%;filter: invert(28%) sepia(98%) saturate(6739%) hue-rotate(356deg) brightness(113%) contrast(123%);opacity: 0.5;" :src="'https://configurator.loxone.com/files/configurations/touch_flex/' + configuration.id  +'/preview.png'" />
            </template>
            <div class="touch__area" :data-id="touch_area.id" @mousedown="clickOnTouchArea(touch_area)" :style="getAreaPosition(touch_area)" v-for="touch_area in configuration.touch_areas" :key="touch_area.id" :class="getTouchAreaClass(touch_area)">
                <div :style="handleTouchAreaStyle(touch_area.data)">
                    <template v-if="touch_area.data && touch_area.data.icon && touch_area.data.text">
                        <div class="image__wrapper combination">
                            <img draggable="false" v-if="touch_area.data.icon" class="touch__area--icon" :width="handleTouchAreaIconSize(touch_area.data)" :height="handleTouchAreaIconSize(touch_area.data)" :src="'https://configurator.loxone.com/files/translations/Icons/' + touch_area.data.icon" />
                        </div>
                        <div :id="'ta-tw-' + touch_area.id" class="text__wrapper combination" :style="handleSingleTextStyle(touch_area)">
                            <div :id="'ta-ti-' + touch_area.id" class="text" v-if="touch_area.data.text">{{touch_area.data.text}}</div>
                        </div>
                    </template>
                    <template v-else-if="touch_area.data && !touch_area.data.icon && touch_area.data.text">
                        <div :id="'ta-tw-' + touch_area.id" class="text__wrapper single" :style="handleSingleTextStyle(touch_area)">
                            <div :id="'ta-ti-' + touch_area.id" :style="handleTextOffset(touch_area.data.text_align)" class="text" v-if="touch_area.data.text">{{touch_area.data.text}}</div>
                        </div>
                    </template>
                    <template v-else-if="touch_area.data && touch_area.data.icon && !touch_area.data.text">
                        <div class="image__wrapper single">
                            <img draggable="false" v-if="touch_area.data.icon" class="touch__area--icon" :width="handleTouchAreaIconSize(touch_area.data)" :height="handleTouchAreaIconSize(touch_area.data)" :src="'https://configurator.loxone.com/files/translations/Icons/' + touch_area.data.icon" />
                        </div>
                    </template>
                </div>
            </div>
            <template v-if="orientationLightVisible">
                <template v-for="touch_area in configuration.touch_areas" :key="touch_area.id">
                    <svg @mousedown="clickOnTouchArea(touch_area, 'functions')" v-if="functionActive(touch_area)" :style="getFunctionPosition(touch_area)" class="function--wrapper" width="34" height="34" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.47998" y="0.67334" width="16" height="16" fill="#69C350"/>
                        <path d="M10.9826 3.47025C10.2364 3.2703 9.46937 3.71315 9.26942 4.45938L8.70699 6.55838L7.68653 6.55843C7.46626 6.55844 7.2877 6.73701 7.28771 6.95728C7.28772 7.17755 7.4663 7.35611 7.68657 7.3561L8.49326 7.35607L7.06946 12.6697C6.98353 12.9904 6.65389 13.1808 6.33319 13.0948C6.12042 13.0378 5.90172 13.1641 5.84471 13.3769C5.7877 13.5896 5.91397 13.8083 6.12673 13.8653C6.87297 14.0653 7.64 13.6224 7.83995 12.8762L9.31908 7.35603L10.4366 7.35598C10.6569 7.35597 10.8355 7.1774 10.8354 6.95712C10.8354 6.73685 10.6569 6.55829 10.4366 6.5583L9.53282 6.55834L10.0399 4.66583C10.1258 4.34513 10.4555 4.15482 10.7762 4.24075C10.989 4.29776 11.2076 4.17149 11.2647 3.95873C11.3217 3.74596 11.1954 3.52726 10.9826 3.47025Z" fill="white"/>
                    </svg>
                    <svg @mousedown="clickOnTouchArea(touch_area, 'functions')" v-else :style="getFunctionPosition(touch_area)" class="function--wrapper" width="34" height="34" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.386658" y="0.5802" width="16" height="16" fill="#808080" fill-opacity="0.25"/>
                        <path d="M10.8893 3.37711C10.1431 3.17716 9.37605 3.62001 9.1761 4.36624L8.61367 6.46524L7.59321 6.46529C7.37294 6.4653 7.19438 6.64387 7.19439 6.86414C7.1944 7.08441 7.37297 7.26297 7.59325 7.26296L8.39993 7.26293L6.97614 12.5766C6.8902 12.8973 6.56056 13.0876 6.23986 13.0017C6.0271 12.9447 5.8084 13.071 5.75139 13.2837C5.69438 13.4965 5.82064 13.7152 6.03341 13.7722C6.77964 13.9721 7.54668 13.5293 7.74663 12.7831L9.22576 7.26289L10.3433 7.26284C10.5636 7.26283 10.7421 7.08426 10.7421 6.86398C10.7421 6.64371 10.5635 6.46515 10.3433 6.46516L9.43949 6.4652L9.94659 4.57269C10.0325 4.25199 10.3622 4.06168 10.6829 4.14761C10.8956 4.20462 11.1143 4.07835 11.1713 3.86559C11.2283 3.65282 11.1021 3.43412 10.8893 3.37711Z" fill="black" fill-opacity="0.5"/>
                    </svg>
                </template>
            </template>
            <div class="status__led" :style="getAreaPosition(status_led)" v-for="status_led in status_leds" :key="status_led">&nbsp;</div>
            <div class="display" :style="getAreaPosition(display)">
                <svg width="340" height="80" viewBox="0 0 340 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1528_114569)">
                        <g filter="url(#filter0_d_1528_114569)">
                            <path d="M231.098 19.1862V7.10075L243.184 7.10075V19.1862H231.098Z" fill="white" fill-opacity="0.88"/>
                            <path d="M231.098 32.6144V20.529H243.184V32.6144H231.098Z" fill="white" fill-opacity="0.88"/>
                            <path d="M231.098 46.0427V33.9573H243.184V46.0427H231.098Z" fill="white" fill-opacity="0.88"/>
                            <path d="M244.527 19.1862V7.10075L256.612 7.10075V19.1862H244.527Z" fill="white" fill-opacity="0.88"/>
                            <path d="M257.955 46.0427V33.9573H270.04V46.0427H257.955Z" fill="white" fill-opacity="0.88"/>
                            <path d="M257.955 59.471V47.3855H270.04V59.471H257.955Z" fill="white" fill-opacity="0.88"/>
                            <path d="M257.955 72.8992V60.8138H270.04V72.8992H257.955Z" fill="white" fill-opacity="0.88"/>
                            <path d="M257.955 32.6144V20.529H270.04V32.6144H257.955Z" fill="white" fill-opacity="0.88"/>
                            <path d="M257.955 19.1862V7.10075H270.04V19.1862H257.955Z" fill="white" fill-opacity="0.88"/>
                            <path d="M231.098 59.471V47.3855H243.184V59.471H231.098Z" fill="white" fill-opacity="0.88"/>
                            <path d="M231.098 72.8992V60.8138H243.184V72.8992H231.098Z" fill="white" fill-opacity="0.88"/>
                            <path d="M284.812 19.1862V7.10075L296.897 7.10075V19.1862H284.812Z" fill="white" fill-opacity="0.88"/>
                            <path d="M298.24 19.1862V7.10075L310.325 7.10075V19.1862H298.24Z" fill="white" fill-opacity="0.88"/>
                            <path d="M284.812 32.6144V20.529H296.897V32.6144H284.812Z" fill="white" fill-opacity="0.88"/>
                            <path d="M284.812 46.0427V33.9573H296.897V46.0427H284.812Z" fill="white" fill-opacity="0.88"/>
                            <path d="M298.24 46.0427V33.9573H310.325V46.0427H298.24Z" fill="white" fill-opacity="0.88"/>
                            <path d="M311.668 72.8992V60.8138H323.753V72.8992H311.668Z" fill="white" fill-opacity="0.88"/>
                            <path d="M311.668 19.1862V7.10075H323.753V19.1862H311.668Z" fill="white" fill-opacity="0.88"/>
                            <path d="M284.812 59.471V47.3855H296.897V59.471H284.812Z" fill="white" fill-opacity="0.88"/>
                            <path d="M284.812 72.8992V60.8138H296.897V72.8992H284.812Z" fill="white" fill-opacity="0.88"/>
                            <path d="M298.24 72.8992V60.8138H310.325V72.8992H298.24Z" fill="white" fill-opacity="0.88"/>
                            <path d="M311.668 46.0427V33.9573H323.753V46.0427H311.668Z" fill="white" fill-opacity="0.88"/>
                            <path d="M177.387 19.1862V7.10075L189.472 7.10075V19.1862H177.387Z" fill="white" fill-opacity="0.88"/>
                            <path d="M190.815 19.1862V7.10075L202.9 7.10075V19.1862H190.815Z" fill="white" fill-opacity="0.88"/>
                            <path d="M177.387 32.6144V20.529H189.472V32.6144H177.387Z" fill="white" fill-opacity="0.88"/>
                            <path d="M177.387 46.0427V33.9573H189.472V46.0427H177.387Z" fill="white" fill-opacity="0.88"/>
                            <path d="M204.243 46.0427V33.9573H216.329V46.0427H204.243Z" fill="white" fill-opacity="0.88"/>
                            <path d="M204.243 59.471V47.3855H216.329V59.471H204.243Z" fill="white" fill-opacity="0.88"/>
                            <path d="M204.243 72.8992V60.8138H216.329V72.8992H204.243Z" fill="white" fill-opacity="0.88"/>
                            <path d="M204.243 32.6144V20.529H216.329V32.6144H204.243Z" fill="white" fill-opacity="0.88"/>
                            <path d="M204.243 19.1862V7.10075H216.329V19.1862H204.243Z" fill="white" fill-opacity="0.88"/>
                            <path d="M177.387 59.471V47.3855H189.472V59.471H177.387Z" fill="white" fill-opacity="0.88"/>
                            <path d="M177.387 72.8992V60.8138H189.472V72.8992H177.387Z" fill="white" fill-opacity="0.88"/>
                            <path d="M190.815 72.8992V60.8138H202.9V72.8992H190.815Z" fill="white" fill-opacity="0.88"/>
                            <path d="M123.671 19.1862V7.10075L135.757 7.10075V19.1862H123.671Z" fill="white" fill-opacity="0.88"/>
                            <path d="M123.671 32.6144V20.529H135.757V32.6144H123.671Z" fill="white" fill-opacity="0.88"/>
                            <path d="M137.1 46.0427V33.9573H149.185V46.0427H137.1Z" fill="white" fill-opacity="0.88"/>
                            <path d="M150.528 59.471V47.3855H162.613V59.471H150.528Z" fill="white" fill-opacity="0.88"/>
                            <path d="M150.528 72.8992V60.8138H162.613V72.8992H150.528Z" fill="white" fill-opacity="0.88"/>
                            <path d="M150.528 32.6144V20.529H162.613V32.6144H150.528Z" fill="white" fill-opacity="0.88"/>
                            <path d="M150.528 19.1862V7.10075H162.613V19.1862H150.528Z" fill="white" fill-opacity="0.88"/>
                            <path d="M123.671 59.471V47.3855H135.757V59.471H123.671Z" fill="white" fill-opacity="0.88"/>
                            <path d="M123.671 72.8992V60.8138H135.757V72.8992H123.671Z" fill="white" fill-opacity="0.88"/>
                            <path d="M69.9598 19.1862V7.10075L82.0453 7.10075V19.1862H69.9598Z" fill="white" fill-opacity="0.88"/>
                            <path d="M83.3881 19.1862V7.10075L95.4735 7.10075V19.1862H83.3881Z" fill="white" fill-opacity="0.88"/>
                            <path d="M69.9598 32.6144V20.529H82.0453V32.6144H69.9598Z" fill="white" fill-opacity="0.88"/>
                            <path d="M69.9598 46.0427V33.9573H82.0453V46.0427H69.9598Z" fill="white" fill-opacity="0.88"/>
                            <path d="M96.8164 46.0427V33.9573H108.902V46.0427H96.8164Z" fill="white" fill-opacity="0.88"/>
                            <path d="M96.8164 59.471V47.3855H108.902V59.471H96.8164Z" fill="white" fill-opacity="0.88"/>
                            <path d="M96.8164 72.8992V60.8138H108.902V72.8992H96.8164Z" fill="white" fill-opacity="0.88"/>
                            <path d="M96.8164 32.6144V20.529H108.902V32.6144H96.8164Z" fill="white" fill-opacity="0.88"/>
                            <path d="M96.8164 19.1862V7.10075H108.902V19.1862H96.8164Z" fill="white" fill-opacity="0.88"/>
                            <path d="M69.9598 59.471V47.3855H82.0453V59.471H69.9598Z" fill="white" fill-opacity="0.88"/>
                            <path d="M69.9598 72.8992V60.8138H82.0453V72.8992H69.9598Z" fill="white" fill-opacity="0.88"/>
                            <path d="M83.3881 72.8992V60.8138H95.4735V72.8992H83.3881Z" fill="white" fill-opacity="0.88"/>
                            <path d="M16.2465 19.1862V7.10077L28.3319 7.10077V19.1862H16.2465Z" fill="white" fill-opacity="0.88"/>
                            <path d="M16.2465 32.6145V20.529H28.3319V32.6145H16.2465Z" fill="white" fill-opacity="0.88"/>
                            <path d="M16.2465 46.0427L16.2465 33.9573H28.3319V46.0427H16.2465Z" fill="white" fill-opacity="0.88"/>
                            <path d="M43.103 72.8992V60.8138H55.1884L55.1884 72.8992H43.103Z" fill="white" fill-opacity="0.88"/>
                            <path d="M16.2465 59.471V47.3855H28.3319L28.3319 59.471H16.2465Z" fill="white" fill-opacity="0.88"/>
                            <path d="M16.2465 72.8992V60.8138H28.3319V72.8992H16.2465Z" fill="white" fill-opacity="0.88"/>
                            <path d="M29.6747 72.8992V60.8138H41.7602V72.8992H29.6747Z" fill="white" fill-opacity="0.88"/>
                        </g>
                    </g>
                <defs>
                    <filter id="filter0_d_1528_114569" x="-6.58247" y="-9.87836" width="353.165" height="111.456" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="5.84982"/>
                        <feGaussianBlur stdDeviation="11.4145"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1528_114569"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1528_114569" result="shape"/>
                    </filter>
                    <clipPath id="clip0_1528_114569">
                        <rect width="340" height="80" fill="white"/>
                    </clipPath>
                </defs>
                </svg>
            </div>
            <div tabindex="991" v-if="orientationLightVisible && (configuration.layout == 'temp_tf_001' || configuration.layout == 'temp_tf_002' || configuration.layout == 'temp_tf_004')" class="orientation__light">
                <div style="position: relative">
                    &nbsp;
                    <div class="box__headline--info" :style="getZoomStyle(currentZoom)">
                        <img src="../assets/images/orientation_light.png" />
                        <h3>{{$t('orientation_light')}}</h3>
                        <p>{{$t('orientation_light_info')}}</p>
                    </div>
                </div>
            </div>
            <div tabindex="991" v-if="orientationLightVisible" class="display__info">
                <div style="position: relative">
                    &nbsp;
                    <div class="box__headline--info" :style="getZoomStyle(currentZoom)">
                        <img src="../assets/images/display.png" />
                        <h3>{{$t('led_display')}}</h3>
                        <p>{{$t('led_display_info')}}</p>
                    </div>
                </div>
            </div>
            <div class="logo" :style="getAreaPosition(logo)">
                <img src="../assets/images/loxone_logo.svg"/>
            </div>
            <div v-if="configuration.up_down_arrows" class="up_down_arrow" :style="getAreaPosition(up_down_arrows[0])">
                <img width="76" height="76" src="https://configurator.loxone.com/files/translations/Icons/arrow-down-2.svg">
            </div>
            <div v-if="configuration.up_down_arrows" class="up_down_arrow" :style="getAreaPosition(up_down_arrows[1])">
                <img width="76" height="76" src="https://configurator.loxone.com/files/translations/Icons/arrow-up-2.svg">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TouchFlex',
    data() {
        return {
            status_leds: [
                {
                    pos_x: 12.95,
                    pos_y: 20.75,
                    width: 1.7,
                    height: 1.7
                },
                {
                    pos_x: 12.95,
                    pos_y: 41.55,
                    width: 1.7,
                    height: 1.7
                },
                {
                    pos_x: 12.95,
                    pos_y: 62.35,
                    width: 1.7,
                    height: 1.7
                }
            ],
            display: {
                pos_x: 28,
                pos_y: 69.1,
                width: 34,
                height: 8.0,
            },
            logo: {
                pos_x: 38.3,
                pos_y: 82,
                width: 13.4,
                height: 2.972,
            },
            up_down_arrows: [
                {
                    pos_x: 10.2,
                    pos_y: 69.5,
                    width: 7.6,
                    height: 7.6,
                },
                {
                    pos_x: 72.6,
                    pos_y: 69.5,
                    width: 7.6,
                    height: 7.6,
                }
            ],
            FIXED_TOUCH_AREA_OFFSET: 3,
        }
    },
    props: {
        configuration: {
            type: Object,
            required: true,
        },
        interactive: {
            type: Boolean,
            required: false,
        },
        activeVal: {
            type: Number,
            required: false,
        },
        currentZoom: {
            type: Number,
            required: false,
        },
        orientationLightVisible: {
            type: Boolean,
            required: false,
        },
    },
    emits: ['mousedown'],
    methods: {
        handleTextOffset(align) {
            if(align == 'left') {
                return 'margin-left: ' + this.FIXED_TOUCH_AREA_OFFSET / 2 * 10 + 'px;';
            } else if(align == 'right') {
                return 'margin-right: ' + this.FIXED_TOUCH_AREA_OFFSET / 2 * 10 + 'px;';
            }
        },
        getZoomStyle(zoom) {
            let scale = 1.5;

            if(zoom == 1) {
                scale = 1.5;
            } else if(zoom == 1.5) {
                scale = 1;
            } else if(zoom == 2) {
                scale = 0.75;
            } else if(zoom == 0.5) {
                scale = 3;
            }

            return {
                transform: `scale(${scale})`,
            }
        },
        getTouchAreaClass(touch_area) {
            let className = '';
            if(touch_area.data && !touch_area.data.icon && !touch_area.data.text){
                className += 'empty';
            } else {
                if('data' in touch_area && 'icon_custom' in touch_area.data && touch_area.data.icon_custom || 'data' in touch_area && 'text_custom' in touch_area.data && touch_area.data.text_custom) {
                    className += 'custom';
                }
            }

            if(this.activeVal && touch_area.id == this.activeVal) {
                className += ' active';
            }

            return className;
        },
        setCookie(name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days*24*60*60*1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "")  + expires + "; path=/";
        },
        getCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0;i < ca.length;i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
        },
        eraseCookie(name) {
            document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        },
        handleTouchAreaIconSize(data) {
            if(data.icon_custom) {
                return data.icon_size * 10;
            } else {
                return this.configuration.icon_size * 10;
            }
        },
        getTouchFlexLayoutClass(data) {
            var classname = "";

            if(data.sku == '100507' || data.sku == '100509') {
                classname += 'touch__flex--white';
                
                } else {
                classname += 'touch__flex--anthracite';

                if(data.glow == true) {
                    classname += ' touch__flex--glow';
                }
            }
            if(!data.id || data.id.substring(0, 4) == "temp") {
                classname += ' touch__flex--template';
            }
            return classname;
        },
        handleTouchAreaStyle(data) {
            var style="display:grid;width:100%;height:100%;grid-template-columns: 100%;";
            if(data) {
                if(data.text && data.icon) {
                    //BOTH
                    style += "grid-template-rows: 70% 30%;";
                } else if(!data.text && data.icon) {
                    //ICON
                    style += "grid-template-rows: 100%;";
                } else if(data.text && !data.icon) {
                    //TEXT
                    style += "grid-template-rows: 100%;";
                }
            }

            return style;
        },
        handleSingleTextStyle(touch_area) {
            var px2mm = 0.28125;
            var style = 'width:100%;height:100%;white-space:pre;';

            if(touch_area.data) {
                if(touch_area.data.text_custom){
                    //Font Size // Line Height
                    style += "font-size:"+touch_area.data.text_size / px2mm+"px;line-height:" + (touch_area.data.text_size / px2mm * 1.2) + "px;";
                    
                    switch(touch_area.data.text_weight) {
                        case 'light':
                            style += "font-family:averta-light;";
                            break;
                        case 'medium':
                            style += "font-family:averta-semibold;";
                            break;
                        default:
                            style += "font-family:averta-regular;";
                            break;
                    }

                } else {
                    //Font Size // Line Height
                    style += "font-size:"+this.configuration.text_size/ px2mm+"px;line-height:" + (this.configuration.text_size / px2mm * 1.2) + "px;";
                    
                    switch(this.configuration.text_style) {
                        case 'light':
                            style += "font-family:averta-light;";
                            break;
                        case 'medium':
                            style += "font-family:averta-semibold;";
                            break;
                        default:
                            style += "font-family:averta-regular;";
                            break;
                    }
                }

                //Positions
                style += "display:flex;";

                if(touch_area.data.icon) {
                    touch_area.data.text_align = 'center';
                    touch_area.data.text_valign = 'center';
                }
                
                if(touch_area.data.text_align) {
                    style += "justify-content:"+touch_area.data.text_align+";text-align:"+touch_area.data.text_align+";";
                } else {
                    style += "justify-content:center;text-align:center;";
                }

                if(touch_area.data.text_valign){
                    style += "align-items:"+touch_area.data.text_valign+";";
                } else {
                    style += "align-items:center;";
                }

            }

            return style;
        },
        getFunctionPosition(data) {
            return 'top:' + (((data.pos_y + data.height) * 10) - 35) + 'px;left:' + (((data.pos_x + data.width) * 10) - 2) + 'px;';
        },
        functionActive(data) {
            if(data && data.data) {
                if(data.data.button_cmd
                || data.data.button_text
                || data.data.arrow_up_cmd
                || data.data.arrow_up_text
                || data.data.arrow_down_cmd
                || data.data.arrow_down_text) {
                    return true;
                }
            }
            return false;
        },
        getAreaPosition(data) {
            return 'top:' + (data.pos_y * 10) + 'px;left:' + (data.pos_x * 10) + 'px;width:' + (data.width * 10) + 'px;height: ' + (data.height * 10) + 'px;';
        },
        
        clickOnTouchArea(touch_area, action = '') {
            if(this.interactive) {
                this.$emit('mousedown', touch_area, action);
            }
        }
    },
}
</script>

<style lang="scss" scoped>
    .text__wrapper{
        //background-color: rgba(0, 0, 255, 0.1);

        &.combination{
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .image__wrapper{
        //background-color: rgba(0, 255, 0, 0.1);

        &.combination,
        &.single{
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .touch__flex{
        box-shadow: 20px 20px 70px 0px rgba(0,0,0,0.5);
        width: 900px;
        height: 900px;
        transform: scale(0.6);
        transform-origin: left top;
        position: relative;
        box-sizing: border-box;

        .touch__area{
            user-select: none;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
        }

        &.touch__flex--anthracite{
            background-image: url('../assets/images/touch_flex_anthracite.png');
            background-repeat: no-repeat;
            background-size: cover;

            .status__led{
                background-color: #CCCCCC;
                opacity: 0.1;
            }

            .touch__area--icon,
            .logo,
            .up_down_arrow{
                filter: invert(1);
                opacity: 0.4;
            }

            &.touch__flex--glow{
                .touch__area--icon,
                .up_down_arrow{
                    opacity: 1;
                    filter: invert(100%) sepia(67%) saturate(2000%) hue-rotate(172deg) brightness(105%) contrast(95%);
                }

                .touch__area .text{
                    color: #000000;
                    opacity: 1;
                    filter: invert(100%) sepia(67%) saturate(2000%) hue-rotate(172deg) brightness(105%) contrast(95%);
                }
            }

            div.text{
                color: #FFFFFF;
                opacity: 0.4;
            }
        }

        &.touch__flex--template{
            .touch__area{
                border: 4px solid grey;
            }
        }

        &.touch__flex--white{
            background-image: url('../assets/images/touch_flex_white.png');
            background-repeat: no-repeat;
            background-size: cover;

            .status__led{
                background-color: rgba(128, 128, 128, 0.25);
            }

            .touch__area--icon,
            .logo,
            .up_down_arrow{             
                opacity: 0.5;
            }

            div.text{     
                opacity: 0.5;
            }
        }

        .orientation__light,
        .display__info{
            cursor: pointer;
            background-image: url('../assets/images/red-dot.svg');
            background-size: cover;
            width: 84px;
            height: 84px;
            border-radius: 50%;
            position: absolute;
            top: 22px;
            left: 22px;

            &:focus .box__headline--info{
                display: block;
            }

            .box__headline--info{
                cursor: initial;
                display: none;
                background-color: #FFFFFF;
                position: absolute;
                top: 40px;
                left: 40px;
                transform-origin: left top;
                z-index: 100;
                box-shadow: 2px 2px 5px 0 rgba(0,0,0,0.7);
                border-radius: 1px;
                text-transform: initial;
                user-select: none;

                img{
                    display: block;
                }

                h3{
                    font-family: 'averta-extrabold', Arial, Helvetica, sans-serif;
                    font-size: 17px;
                    text-transform: uppercase;
                    padding: 15px;
                    border-top: 1px solid #CFCFCF;
                    text-transform: uppercase;
                    line-height: 12px;
                }

                p{
                    font-family: 'averta-regular', Arial, Helvetica, sans-serif;
                    margin: 0;
                    padding: 0 15px 15px 15px;
                    color: #575C61;
                    font-size: 15px;
                    line-height: 18px;
                }

                .btns{
                    display: grid;
                    grid-template-columns: calc(50% - 5px) calc(50% - 5px);
                    grid-column-gap: 10px;
                    padding: 0 15px 15px 15px;

                    .btn{
                        font-size: 15px;
                        height: 32px;
                        line-height: 28px;
                        padding: 0 10px;
                        min-width: 50px;
                    }
                }
            }
        }
        .display__info{
         top: 680px;
         left: 270px;
         background-color: #E73246;
         background-image: none;
         width: 36px;
         height: 36px;

            .box__headline--info{
                bottom: -20px;
                top: initial;
                transform-origin: left bottom;
            }
        }

        .logo,
        .display,
        .status__led,
        .touch__area,
        .up_down_arrow{
            position: absolute;
        }

        .status__led{
            border-radius: 50%;
        }
    }

    .function--wrapper{
        cursor: pointer;
        position: absolute;
    }
</style>